import React, { useState } from "react";
import { pricingData } from "../config/data";
import { useUser } from "../context/useInfo";

const SubscribeFields = () => {
  const [selectedOption, setSelectedOption] = useState(pricingData[1]);
  const { updateUserData } = useUser();

  const handleStripe = (option) => {
    setSelectedOption(option);
    updateUserData({ selectedOption: option });
  };

  return (
    <div className="space-y-3 mb-5">
      {pricingData.map((option, index) => (
        <div
          key={option.discount}
          className={`relative flex items-center gap-2 w-full py-3 px-4 rounded-xl border text-sm transition cursor-pointer
            ${
              selectedOption === option
                ? index === 1
                  ? "bg-pink-200 border-pink-400"
                  : "bg-gray-200 border-gray-400"
                : index === 1
                ? "bg-pink-50 border-pink-300 hover:bg-pink-200"
                : "bg-gray-50 border hover:bg-gray-100"
            }`}
          onClick={() => handleStripe(option)}
        >
          <div
            className={`w-5 h-5 rounded-full border-2 flex items-center justify-center 
              ${
                selectedOption === option
                  ? "border-pink-500 bg-pink-500"
                  : "border-gray-300"
              }`}
          >
            {selectedOption === option && (
              <svg
                className="w-3 h-3 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
          <div className="flex flex-col text-sm">
            <span className="text-center text-2xl">{option.title}</span>
            <span className="relative inline-block text-gray-600">
              {option.price} → {option.priceWithDiscount}
              <span className="absolute left-0 top-1/2 w-11 h-[1px] bg-gray-600"></span>
            </span>
          </div>
          <div className="flex flex-col justify-between w-50 h-50 py-3 px-5 bg-gray-50 rounded-xl border text-sm ml-auto">
            <span className="text-center text-gray-600 font-bold line-through">
              {option.beforPrice}
            </span>
            <span className="text-center text-lg font-bold">
              {option.nowPrice}
            </span>
            <span className="text-center text-gray-600 font-bold">
              per day
            </span>
          </div>
          {index === 1 && (
            <div
              className="absolute bg-pink-500 rounded-lg inline-block px-2 py-1"
              style={{ bottom: "92px", left: 0 }}
            >
              <span className="text-center text-md text-white whitespace-nowrap">
                MOST POPULAR
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SubscribeFields;
